import React, {useEffect, useState} from "react";
import Spinner from "../../../components/spinner/Spinner";
import common from "../../../translations/it/common.json";
import Autocomplete from "../../../components/Autocomplete/Autocomplete";
import Input from "../../../components/inputText/Input";
import Icon from "../../../components/icon/Icon";
import orologioIcon from "../../../img/icons/clock_102733.png";
import Select from "../../../components/Select/Select";
import oggettiUtili from "../../../utils/OggettiUtili.json";
import Button from "../../../components/Button/Button";
import CheckBox from "../../../components/checkBox/CheckBox";
import TextArea from "../../../components/TextArea/TextArea";
import $ from "jquery";

function FormSportello(props) {

    const [form, setForm] = useState(null)
    const comuni = JSON.parse(sessionStorage.getItem("comuniCoordinate"))
    useEffect(() => {
        createForm()
    }, [props])


    $(function () {
        let e = $('[data-toggle="popoverLatitudine"]').popover({
            html: true,
            content: '<span class="popover-content">Esempio coordinate Venezia </br>Latitudine: 45.44229 </br>Longitudine: 12.31302 </span>'
        });
        e = e.data('bs.popover') && e.data('bs.popover').getTipElement() ? e.data('bs.popover').getTipElement() : null
    });

    $(function () {
        let e = $('[data-toggle="popoverLongitudine"]').popover({
            html: true,
            content: '<span class="popover-content">Esempio coordinate Venezia </br>Latitudine: 45.44229 </br>Longitudine: 12.31302 </span>'
        });
        e = e.data('bs.popover') && e.data('bs.popover').getTipElement() ? e.data('bs.popover').getTipElement() : null
    });

    function createForm() {
        let newForm = (
            <div>
                <Spinner show={props.showSpinner}/>
                <div style={{float: "right"}}>
                    <p style={{fontWeight: "bold", fontSize: "16px", color: "red"}}>Campo obbligatorio*</p>
                </div>
                <br/>
                <div className={"row"}>
                    <div className="col-5">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>{common.ModaleSportello.comune}</span>
                        <span style={{color: "red", fontWeight: "bold", marginLeft: "3px"}}>*</span>
                        <Autocomplete
                            id={props.modifica ? "comuneModifica".concat(props.state.id ? props.state.id : "") : "comune"}
                            value={props.state.comune ? props.state.comune : ""}
                            onChange={props.onChange}
                            placeholder={"Comune"}
                            suggestions={comuni}
                            rerender={props.rerenderAutocomplete}
                        />
                    </div>
                    <div className="col-5">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>{common.ModaleSportello.indirizzo}</span>
                        <span style={{color: "red", fontWeight: "bold", marginLeft: "3px"}}>*</span>
                        <Input
                            id={props.modifica ? "indirizzoModifica".concat(props.state.id ? props.state.id : "") : "indirizzo"}
                            value={props.state.indirizzo ? props.state.indirizzo : ""}
                            onChange={(event) => props.onChange(event.target.id, event.target.value)}
                            placeholder={"Indirizzo"}
                        />
                    </div>
                    <div className="col-2">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>{common.ModaleSportello.cap}</span>
                        <span style={{color: "red", fontWeight: "bold", marginLeft: "3px"}}>*</span>
                        <Input
                            id={props.modifica ? "capModifica".concat(props.state.id ? props.state.id : "") : "cap"}
                            value={props.state.cap ? props.state.cap : ""}
                            onChange={(event) => props.onChange(event.target.id, event.target.value)}
                            placeholder={"CAP"}
                        />
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className={"col-6"}>
                        <span
                            style={{fontWeight: "normal", fontSize: "22px"}}>{common.ModaleSportello.latitudine}</span>
                        <span style={{color: "red", fontWeight: "bold", marginLeft: "3px"}}>*</span>
                        <a data-toggle="popoverLatitudine" data-container="body" data-trigger="hover">
                            <svg width="22" height="22" id="it-info-circle" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-.7-15h1.5v2h-1.5zm0 3h1.5v9h-1.5z"/>
                                <path fill="none" d="M0 0h24v24H0z"/>
                            </svg>
                        </a>
                        <Input
                            id={props.modifica ? "latitudineModifica".concat(props.state.id ? props.state.id : "") : "latitudine"}
                            value={props.state.latitudine ? props.state.latitudine : ""}
                            onChange={(event) => props.onChange(event.target.id, event.target.value)}
                            placeholder={"Latitudine"}
                        />
                    </div>
                    <div className={"col-6"}>
                        <span
                            style={{fontWeight: "normal", fontSize: "22px"}}>{common.ModaleSportello.longitudine}</span>
                        <span style={{color: "red", fontWeight: "bold", marginLeft: "3px"}}>*</span>
                        <a data-toggle="popoverLongitudine" data-container="body" data-trigger="hover">
                            <svg width="22" height="22" id="it-info-circle" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-.7-15h1.5v2h-1.5zm0 3h1.5v9h-1.5z"/>
                                <path fill="none" d="M0 0h24v24H0z"/>
                            </svg>
                        </a>
                        <Input
                            id={props.modifica ? "longitudineModifica".concat(props.state.id ? props.state.id : "") : "longitudine"}
                            value={props.state.longitudine ? props.state.longitudine : ""}
                            onChange={(event) => props.onChange(event.target.id, event.target.value)}
                            placeholder={"Longitudine"}
                        />
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className="col-12">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>{common.ModaleSportello.referente}</span>
                        <span style={{color: "red", fontWeight: "bold", marginLeft: "3px"}}>*</span>
                        <Input
                            id={props.modifica ? "referenteModifica".concat(props.state.id ? props.state.id : "") : "referente"}
                            value={props.state.referente ? props.state.referente : ""}
                            onChange={(event) => props.onChange(event.target.id, event.target.value)}
                            placeholder={"Referente"}
                        />
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className="col-5">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>{common.Modale.telefono}</span>
                        <span style={{color: "red", fontWeight: "bold", marginLeft: "3px"}}>*</span>
                        <Input
                            id={props.modifica ? "telefonoModifica".concat(props.state.id ? props.state.id : "") : "telefono"}
                            value={props.state.telefono ? props.state.telefono : ""}
                            onChange={(event) => props.onChange(event.target.id, event.target.value)}
                            placeholder={"Telefono"}
                        />
                    </div>
                    <div className="col-2"/>
                    <div className="col-5">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>{common.Modale.email}</span>
                        <span style={{color: "red", fontWeight: "bold", marginLeft: "3px"}}>*</span>
                        <Input
                            id={props.modifica ? "emailModifica".concat(props.state.id ? props.state.id : "") : "email"}
                            value={props.state.email ? props.state.email : ""}
                            onChange={(event) => props.onChange(event.target.id, event.target.value)}
                            placeholder={"Email"}
                        />
                    </div>
                </div>


                <div className={"row"} style={{marginTop: "40px"}}>
                    <div className="col-12">
                        <div className={"row"}>
                            <div className="col-1">
                                <div style={{
                                    width: "48px",
                                    display: "flex",
                                    alignItems: "baseline",
                                    justifyContent: "center"
                                }}>
                                    <Icon path={orologioIcon} height="30px" width="30px"/>
                                </div>
                            </div>
                            <div className="col-6">
                                <span
                                    style={{fontWeight: "bold", fontSize: "18px"}}>{common.ModaleSportello.orari}</span>
                            </div>
                        </div>

                        <div className={"row"} style={{marginTop: "15px"}}>
                            <div className="col-1"></div>
                            <div className="col-4" style={{marginTop: "0.5rem"}}>
                                <span style={{
                                    fontWeight: "bold",
                                    fontSize: "18px"
                                }}>{common.ModaleSportello.appuntamento}</span>
                            </div>
                            <div className="col-2">
                                <CheckBox
                                    id={props.modifica ? "appuntamentoModifica".concat(props.state.id ? props.state.id : "") : "appuntamento"}
                                    checked={props.state.appuntamento ? props.state.appuntamento : ""}
                                    onChange={(event) => props.onChange(event.target.id, event.target.checked)}/>
                            </div>
                        </div>

                        <div className={"row"}>
                            <div className="col-12"
                                 style={{display: "flex", justifyContent: "center", marginTop: "2px"}}>
                                <span style={{fontWeight: "bold", fontStyle: "italic", fontSize: "18px"}}>oppure</span>
                            </div>
                        </div>

                    </div>
                </div>
                <div className={"row"} style={{marginTop: "15px"}}>
                    <div className="col-2"/>
                    <div className="col-5" style={{textAlign: "center"}}>
                        <span style={{fontSize: "18px", fontStyle: "oblique"}}>Mattina</span>
                    </div>
                    <div className="col-5" style={{textAlign: "center"}}>
                        <span style={{fontSize: "18px", fontStyle: "oblique"}}>Pomeriggio</span>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>Lunedì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"lunediMattina1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.lunediMattina1 ? props.state.orari.lunediMattina1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"lunediMattina2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.lunediMattina2 ? props.state.orari.lunediMattina2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"lunediPomeriggio1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.lunediPomeriggio1 ? props.state.orari.lunediPomeriggio1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"lunediPomeriggio2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.lunediPomeriggio2 ? props.state.orari.lunediPomeriggio2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>Martedì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"martediMattina1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.martediMattina1 ? props.state.orari.martediMattina1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"martediMattina2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.martediMattina2 ? props.state.orari.martediMattina2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"martediPomeriggio1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.martediPomeriggio1 ? props.state.orari.martediPomeriggio1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"martediPomeriggio2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.martediPomeriggio2 ? props.state.orari.martediPomeriggio2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>Mercoledì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"mercolediMattina1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.mercolediMattina1 ? props.state.orari.mercolediMattina1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"mercolediMattina2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.mercolediMattina2 ? props.state.orari.mercolediMattina2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"mercolediPomeriggio1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.mercolediPomeriggio1 ? props.state.orari.mercolediPomeriggio1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"mercolediPomeriggio2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.mercolediPomeriggio2 ? props.state.orari.mercolediPomeriggio2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>Giovedì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"giovediMattina1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.giovediMattina1 ? props.state.orari.giovediMattina1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"giovediMattina2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.giovediMattina2 ? props.state.orari.giovediMattina2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"giovediPomeriggio1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.giovediPomeriggio1 ? props.state.orari.giovediPomeriggio1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"giovediPomeriggio2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.giovediPomeriggio2 ? props.state.orari.giovediPomeriggio2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>Venerdì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"venerdiMattina1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.venerdiMattina1 ? props.state.orari.venerdiMattina1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"venerdiMattina2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.venerdiMattina2 ? props.state.orari.venerdiMattina2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"venerdiPomeriggio1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.venerdiPomeriggio1 ? props.state.orari.venerdiPomeriggio1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"venerdiPomeriggio2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.venerdiPomeriggio2 ? props.state.orari.venerdiPomeriggio2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span style={{fontWeight: "normal", fontSize: "22px"}}>Sabato</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"sabatoMattina1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.sabatoMattina1 ? props.state.orari.sabatoMattina1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"sabatoMattina2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.sabatoMattina2 ? props.state.orari.sabatoMattina2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "center"}}>
                            <div className="col-5">
                                <Select id={"sabatoPomeriggio1"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.sabatoPomeriggio1 ? props.state.orari.sabatoPomeriggio1 : ""}
                                />
                            </div>
                            <div className="col-5">
                                <Select id={"sabatoPomeriggio2"}
                                        options={oggettiUtili.orariSportello}
                                        onChange={(event) => props.onChangeOrari(event.target.id, event.target.value)}
                                        placeholder={"Orario"}
                                        value={props.state.orari && props.state.orari.sabatoPomeriggio2 ? props.state.orari.sabatoPomeriggio2 : ""}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className="col-4" style={{marginTop: "2px"}}>
                        <span style={{fontWeight: "bold", fontSize: "18px"}}>{common.ModaleSportello.note}</span>
                    </div>
                </div>
                <div className={"row"} style={{marginBottom: "1rem"}}>
                    <div className="col-12">
                        <TextArea id={"note"} rows={"5"}
                                  value={props.state.note ? props.state.note : ""}
                                  onChange={(event) => props.onChange(event.target.id, event.target.value)}
                        />
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "1rem", marginBottom: "1rem"}}>
                    <div className="col-6">
                        <Button
                            id={"annulla"}
                            onClick={props.onClickAnnulla}
                            typeButton={"White"}
                            disabled={false}
                            text={"Annulla"}
                            style={{height: "45px", width: "180px", float: "left"}}
                            dataDismiss="modal"
                        />
                    </div>
                    <div className="col-6">
                        <Button
                            id={props.modifica ? "modifica" : "salva"}
                            onClick={props.onClickSalvaModifica}
                            typeButton={"Blue"}
                            disabled={props.disabledButtonSalvaModifica}
                            text={"Salva"}
                            style={{height: "45px", width: "180px", float: "right"}}
                            dataDismiss="modal"
                        />
                    </div>
                </div>


            </div>
        )
        setForm(newForm)
    }

    return (form)

}

export default FormSportello


